import React from "react";
import { MapPin, Building2, Scale, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TheCarolinasAdvantage() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const benefits = [{
    icon: <Scale className="size-5" />,
    text: "Localized Insight into Carolinas’ Tax Laws"
  }, {
    icon: <Building2 className="size-5" />,
    text: "Real Estate Investment Advisory"
  }, {
    icon: <MapPin className="size-5" />,
    text: "Regional Expertise in NC & SC Markets"
  }];
  return <section id="the-carolinas-advantage" className="dark bg-background text-foreground py-20 lg:py-32 relative overflow-hidden" ref={ref}>
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] bg-secondary/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-0 items-center">
          
          {}
          <div className={cn("lg:col-span-7 relative min-h-[400px] lg:min-h-[600px] w-full transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10")}>
            {}
            <div className="absolute top-0 left-0 w-[90%] h-[85%] rounded-sm overflow-hidden shadow-xl border border-white/10">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1563866/img/carolinas_regional_map_abstract.png" alt="Map of North and South Carolina" className="w-full h-full object-cover opacity-60 hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-primary/20 mix-blend-overlay" />
            </div>

            {}
            <div className="absolute bottom-0 right-0 lg:right-12 w-[65%] h-[60%] rounded-sm overflow-hidden shadow-2xl border-4 border-background z-10">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1563866/img/charlotte_luxury_estate_detail.png" alt="Luxury Estate in Charlotte" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
            
            {}
            <div className="absolute top-[10%] right-[5%] w-[1px] h-[40%] bg-secondary/30 hidden lg:block" />
          </div>

          {}
          <div className={cn("lg:col-span-5 relative z-20 transition-all duration-1000 delay-300 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
            {}
            <Card className="bg-white text-slate-900 border-none shadow-2xl lg:-ml-24 rounded-sm overflow-hidden">
              <CardContent className="p-8 lg:p-10 flex flex-col gap-6">
                <div>
                  <h4 className="text-secondary font-medium tracking-widest text-xs uppercase mb-3">
                    Regional Dominance
                  </h4>
                  <h2 className="text-3xl lg:text-4xl font-serif font-semibold leading-tight text-slate-900 mb-4">
                    The Carolinas Advantage
                  </h2>
                  <p className="text-slate-600 leading-relaxed">
                    Cyradon Capital is a Charlotte‑based financial advisory serving wealth building and asset protection, real‑estate investors, and small‑business owners across North and South Carolina. We combine deep regional expertise with sophisticated wealth management strategies.
                  </p>
                </div>

                <div className="space-y-4">
                  {benefits.map((item, i) => <div key={i} data-index={i} className="flex items-start gap-3 group">
                      <div className="mt-1 p-1.5 rounded-full bg-slate-100 text-secondary group-hover:bg-secondary group-hover:text-white transition-colors">
                        {item.icon}
                      </div>
                      <span className="text-slate-700 font-medium text-sm lg:text-base pt-1">
                        {item.text}
                      </span>
                    </div>)}
                </div>

                <div className="pt-4 border-t border-slate-100 mt-2">
                  <Button asChild className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90">
                    <Link to="/TheCarolinasEdgePage">
                      Explore Our Regional Focus
                      <ArrowRight className="ml-2 size-4" />
                    </Link>
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}